import React from "react";

type ModuleItem = { module_name?: string; module_category?: string };

/*
	Фильтрует список переданных панелей (React-элементов) по модулям, доступным
	в текущем разделе (section).
 
	Пример: section = 'chat', appModules содержит { module_name: 'chat_history' }
	и в panes есть элемент с key='history' — он будет включён.
 
	Логика совпадения: берём key React-элемента (приводим к строке) и считаем совпадающим,
	если module_name === key, module_name.endsWith(`_${key}`) или module_name.includes(key).
	Это даёт гибкость в именовании (chat_history, history, history_list и т.д.).
*/
export const filterModules = (
	section: string,
	panes: React.ReactNode[],
	appModulesConfig?: {
		moduleName: string;
		moduleCategory: string;
		moduleOrder: number;
		moduleWeight: number;
	}[],
): React.ReactNode[] => {
	// Если не переданы компоненты для отображения
	if (!panes || panes.length === 0) return [];

	// Фильтруем модули по весу
	const appModulesByWeight = appModulesConfig?.filter(
		(item) => Number(item.moduleWeight) !== 0,
	);
	// Фильтруем по секции
	const appModulesBySection = appModulesByWeight?.filter(
		(item) => item.moduleCategory === section,
	);
	// Сортируем по moduleOrder
	const sortedModulesByOrder = appModulesBySection?.sort(
		(a, b) => Number(a.moduleOrder ?? 0) - Number(b.moduleOrder ?? 0),
	);

	// Функция совпадения имени модуля и key компонента
	const matchModuleToPane = (moduleName: string, pane: React.ReactNode) => {
		if (!React.isValidElement(pane)) return false;
		const key = String((pane as any).key ?? (pane as any).props?.id ?? "");
		if (!key) return false;
		return moduleName === key;
	};

	// Возвращаем модули в порядке sortedModulesByOrder
	const result: React.ReactNode[] = (sortedModulesByOrder ?? [])
		.map((mod) => {
			const pane = panes.find((p) =>
				matchModuleToPane(String(mod.moduleName), p),
			);
			return pane ?? null;
		})
		.filter(Boolean) as React.ReactNode[];

	return result;
};

export default filterModules;
